// extracted by mini-css-extract-plugin
export default {"loading":"interactive-document_loading__20Lao"};